import React, { useMemo } from "react";
import { node, number, oneOf, oneOfType, shape, string } from "prop-types";

import classes from "./shimmer.module.css";

const Shimmer = (props) => {
  const {
    classes: propClasses,
    borderRadius,
    height,
    width,
    style: customStyles,
    type,
    children,
    ...restProps
  } = props;

  const style = useMemo(() => {
    const combinedStyles = {
      ...customStyles,
    };

    Object.entries({ borderRadius, height, width }).forEach(([type, value]) => {
      if (typeof value !== "undefined") {
        combinedStyles[type] =
          typeof value === "number" ? `${value}rem` : value;
      }
    });

    return combinedStyles;
  }, [customStyles, borderRadius, height, width]);

  const rootClass = `root_${type}`;

  return (
    <div className={classes[rootClass]} style={style} {...restProps}>
      {children}
    </div>
  );
};

Shimmer.propTypes = {
  classes: shape({
    root: string,
    root_rectangle: string,
    root_button: string,
    root_checkbox: string,
    root_radio: string,
    root_textArea: string,
    root_textInput: string,
  }),
  borderRadius: oneOfType([number, string]),
  height: oneOfType([number, string]),
  width: oneOfType([number, string]),
  style: shape({}),
  type: oneOf([
    "rectangle",
    "button",
    "checkbox",
    "radio",
    "textArea",
    "textInput",
  ]),
  children: node,
};

Shimmer.defaultProps = {
  style: {},
  type: "rectangle",
};

export default Shimmer;
